/* eslint-disable no-undef */

import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { getHeaders } from "../../../utility/getHeader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../../../layout/Layout';
import { Form, Input, Button, Select, Table, Space, Modal, Card, Tag } from 'antd';
import { UserAddOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import fetchData from "../../../functions/fetchData";
import './NewUser.css';

export default function NewUser() {
    let currentDate = dayjs().format("YYYY-MM-DD");
    //  const headers = { Authorization: authheader().access_token };
    const [data, setData] = useState([]);
    const [errors, setErrors] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [formdata, setFormData] = useState({
        name: "",
        pass: "",
        contact: "",
        email: "",
        usertype: "",
        lastloggedin: currentDate,
    });
    const columns = [
        { label: 'Name', field: 'name' },
        { label: 'Uname', field: 'uname' },
        { label: 'Contact', field: 'contact' },
        { label: 'Email', field: 'email' },
        { label: 'Type', field: 'type' },
        { label: 'Last Loggedin', field: 'last_loggedin' },
        { label: "Actions", field: "actions" }
    ];
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // alert(e.target);
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await axios.post(
                "/register",
                {
                    name: formdata.name,
                    pass: formdata.pass,
                    contact: formdata.contact,
                    email: formdata.email,
                    type: formdata.usertype,
                    lastloggedin: currentDate,
                },
                getHeaders()
            );

            // Fetch the updated data after successful submission
            await fetchData('users', setData, 'id', {});

            toast.success('User added successfully!');
            
            // Reset form data with proper structure
            setFormData({
                name: "",
                pass: "",
                contact: "",
                email: "",
                usertype: "",
                lastloggedin: currentDate,
            });
        } catch (err) {
            // Handle specific error codes
            if (err.response?.status === 409) {
                toast.error('User already exists! Please use a different email or contact number.');
            } else if (err.response?.status === 400) {
                toast.error('Invalid data! Please check all fields.');
            } else {
                toast.error('Error in adding user. Please try again.');
            }
            console.error('Error adding user:', err.message);
        }
    };

    //Fetch data query 
    const handleFilter = (field) => {
        // Show a filter UI or perform a filtering action based on the clicked field
        console.log(`Filter clicked for: ${field}`);
    };

    const handleEdit = (user) => {
        setEditingUser({
            id: user.id,
            name: user.name,
            contact: user.contact,
            email: user.email,
            pass: "", // Empty password field
        });
        setShowEditModal(true);
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setEditingUser((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleUpdateUser = async (e) => {
        e.preventDefault();
        try {
            const updateData = {
                name: editingUser.name,
                contact: editingUser.contact,
                email: editingUser.email,
            };
            
            // Only include password if it's provided
            if (editingUser.pass && editingUser.pass.trim() !== "") {
                updateData.pass = editingUser.pass;
            }

            await axios.put(
                `/updatecommondata/users/id/${editingUser.id}`,
                updateData,
                getHeaders()
            );

            toast.success('User updated successfully!');
            setShowEditModal(false);
            setEditingUser(null);
            
            // Refresh the data
            await fetchData('users', setData, 'id', {});
        } catch (err) {
            toast.error('Error updating user. Please try again.');
            console.error('Error updating user:', err.message);
        }
    };

    const handleCloseModal = () => {
        setShowEditModal(false);
        setEditingUser(null);
    };

    const handleDelete = (user) => {
        Modal.confirm({
            title: 'Delete User',
            content: `Are you sure you want to delete "${user.name}"? This action cannot be undone.`,
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: async () => {
                try {
                    await axios.delete(`/deletebyid/users/id/${user.id}`, getHeaders());
                    toast.success('User deleted successfully!');
                    await fetchData('users', setData, 'id', {});
                } catch (err) {
                    toast.error('Error deleting user. Please try again.');
                    console.error('Error deleting user:', err.message);
                }
            },
        });
    };

    useEffect(() => {

        const fetchAndSetData = async () => {
            try {
                await fetchData('users', setData, 'id', {});
                console.log('Fetched data:', data); // Add this line for debugging
            } catch (error) {
                console.error('Error in useEffect:', error);
            }
        };

        fetchAndSetData();

    }, []);

    // Filter and paginate data
    const filteredData = data.filter(user => {
        const query = searchQuery.toLowerCase();
        return (
            (user.name && user.name.toLowerCase().includes(query)) ||
            (user.uname && user.uname.toLowerCase().includes(query)) ||
            (user.contact && user.contact.toLowerCase().includes(query)) ||
            (user.email && user.email.toLowerCase().includes(query)) ||
            (user.type && user.type.toLowerCase().includes(query))
        );
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    return (
        <>
            <Layout>
                <div className="new-user-container">
                    <div className="new-user-header">
                        <h2><i className="fa fa-users"></i> User Management</h2>
                        <p>Add and manage system users</p>
                    </div>

                    <ToastContainer position="top-right" autoClose={3000} />

                    {/* Add User Form */}
                    <div className="nu-card">
                        <div className="nu-card-header">
                            <i className="fa fa-user-plus"></i>
                            Add New User
                        </div>
                        <div className="nu-card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="nu-form-row">
                                    <div className="nu-form-group">
                                        <label className="nu-label">Full Name *</label>
                                        <input
                                            type="text"
                                            className="nu-input"
                                            name="name"
                                            value={formdata.name}
                                            onChange={handleInputChange}
                                            placeholder="Enter full name"
                                            required
                                        />
                                    </div>
                                    <div className="nu-form-group">
                                        <label className="nu-label">Password *</label>
                                        <input
                                            type="password"
                                            className="nu-input"
                                            name="pass"
                                            value={formdata.pass}
                                            onChange={handleInputChange}
                                            placeholder="Enter password"
                                            required
                                        />
                                    </div>
                                    <div className="nu-form-group">
                                        <label className="nu-label">Contact Number</label>
                                        <input
                                            type="text"
                                            className="nu-input"
                                            name="contact"
                                            value={formdata.contact}
                                            onChange={handleInputChange}
                                            placeholder="Enter contact number"
                                        />
                                    </div>
                                </div>

                                <div className="nu-form-row">
                                    <div className="nu-form-group">
                                        <label className="nu-label">Email Address</label>
                                        <input
                                            type="email"
                                            className="nu-input"
                                            name="email"
                                            value={formdata.email}
                                            onChange={handleInputChange}
                                            placeholder="Enter email address"
                                        />
                                    </div>
                                    <div className="nu-form-group">
                                        <label className="nu-label">User Type *</label>
                                        <div className="nu-select-wrapper">
                                            <select
                                                className="nu-select"
                                                name="usertype"
                                                value={formdata.usertype}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Select User Type</option>
                                                <option value="promotor">Promotor</option>
                                                <option value="captain">Captain</option>
                                                <option value="sale_view">Viewer</option>
                                                <option value="Account">Account</option>
                                                <option value="Cashier">Cashier</option>
                                                <option value="checker">Door Checker</option>
                                                <option value="wstoremanager">Warehouse Store Manager</option>
                                                <option value="cstoremanager">Club Store Manager</option>
                                                <option value="modifier">Modifier</option>
                                                <option value="bar">Bar</option>
                                                <option value="kitchen">Kitchen</option>
                                                <option value="HR">HR</option>
                                                <option value="Admin">Admin</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="nu-form-group">
                                        <label className="nu-label" style={{ opacity: 0 }}>Submit</label>
                                        <button type="submit" className="nu-btn nu-btn-success" style={{ width: '100%' }}>
                                            <i className="fa fa-save"></i> Save User
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Users List */}
                    <div className="nu-card">
                        <div className="nu-card-header">
                            <i className="fa fa-list"></i>
                            Users List
                        </div>
                        <div className="nu-card-body" style={{ padding: '20px 20px 0 20px' }}>
                            {/* Search Bar */}
                            <div className="nu-search-wrapper">
                                <i className="fa fa-search nu-search-icon"></i>
                                <input
                                    type="text"
                                    className="nu-search-input"
                                    placeholder="Search by name, username, contact, email, or type..."
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />
                                {searchQuery && (
                                    <button 
                                        className="nu-search-clear"
                                        onClick={() => {
                                            setSearchQuery("");
                                            setCurrentPage(1);
                                        }}
                                    >
                                        <i className="fa fa-times"></i>
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="nu-card-body" style={{ padding: '0' }}>
                            {filteredData.length === 0 ? (
                                <div className="nu-alert nu-alert-info" style={{ margin: '20px' }}>
                                    <i className="fa fa-info-circle"></i>
                                    <span>{searchQuery ? `No users found matching "${searchQuery}"` : 'No users available'}</span>
                                </div>
                            ) : (
                                <>
                                <div className="nu-table-wrapper">
                                    <table className="nu-table">
                                        <thead>
                                            <tr>
                                                {columns.map((col, index) => (
                                                    <th key={index}>{col.label}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentItems.map((user, index) => (
                                                <tr key={index}>
                                                    <td>{user.name || '-'}</td>
                                                    <td>{user.uname || '-'}</td>
                                                    <td>{user.contact || '-'}</td>
                                                    <td>{user.email || '-'}</td>
                                                    <td>
                                                        <span className="nu-badge nu-badge-info">
                                                            {user.type || '-'}
                                                        </span>
                                                    </td>
                                                    <td>{user.last_loggedin && user.last_loggedin !== '0000-00-00 00:00:00' ? dayjs(user.last_loggedin).format('DD/MM/YYYY') : '-'}</td>
                                                    <td>
                                                        <div className="nu-action-buttons">
                                                            <button 
                                                                className="nu-btn nu-btn-warning nu-btn-sm" 
                                                                onClick={() => handleEdit(user)}
                                                                title="Edit User"
                                                            >
                                                                <i className="fa fa-edit"></i>
                                                            </button>
                                                            <button
                                                                className="nu-btn nu-btn-danger nu-btn-sm"
                                                                onClick={() => handleDelete(user)}
                                                                title="Delete User"
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                <div className="nu-pagination">
                                    <div className="nu-pagination-info">
                                        Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} users
                                    </div>
                                    <div className="nu-pagination-controls">
                                        <button 
                                            className="nu-btn nu-btn-sm nu-btn-secondary"
                                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                            disabled={currentPage === 1}
                                        >
                                            <i className="fa fa-chevron-left"></i> Previous
                                        </button>
                                        <span className="nu-pagination-pages">
                                            Page {currentPage} of {totalPages}
                                        </span>
                                        <button 
                                            className="nu-btn nu-btn-sm nu-btn-secondary"
                                            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next <i className="fa fa-chevron-right"></i>
                                        </button>
                                    </div>
                                    <div className="nu-pagination-select">
                                        <label>Show:</label>
                                        <select 
                                            value={itemsPerPage} 
                                            onChange={(e) => {
                                                setItemsPerPage(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}
                                            className="nu-select"
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                    </div>
                                </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Edit User Modal */}
                {showEditModal && editingUser && (
                    <div className="nu-modal-overlay" onClick={handleCloseModal}>
                        <div className="nu-modal" onClick={(e) => e.stopPropagation()}>
                            <div className="nu-modal-header">
                                <h5><i className="fa fa-edit"></i> Edit User</h5>
                                <button className="nu-modal-close" onClick={handleCloseModal}>
                                    &times;
                                </button>
                            </div>
                            <form onSubmit={handleUpdateUser}>
                                <div className="nu-modal-body">
                                    <div className="nu-form-row">
                                        <div className="nu-form-group">
                                            <label className="nu-label">Full Name *</label>
                                            <input
                                                type="text"
                                                className="nu-input"
                                                name="name"
                                                value={editingUser.name}
                                                onChange={handleEditInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="nu-form-group">
                                            <label className="nu-label">Contact Number</label>
                                            <input
                                                type="text"
                                                className="nu-input"
                                                name="contact"
                                                value={editingUser.contact}
                                                onChange={handleEditInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="nu-form-row">
                                        <div className="nu-form-group">
                                            <label className="nu-label">Email Address</label>
                                            <input
                                                type="email"
                                                className="nu-input"
                                                name="email"
                                                value={editingUser.email}
                                                onChange={handleEditInputChange}
                                            />
                                        </div>
                                        <div className="nu-form-group">
                                            <label className="nu-label">New Password (optional)</label>
                                            <input
                                                type="password"
                                                className="nu-input"
                                                name="pass"
                                                value={editingUser.pass}
                                                onChange={handleEditInputChange}
                                                placeholder="Leave empty to keep current password"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="nu-modal-footer">
                                    <button type="button" className="nu-btn nu-btn-secondary" onClick={handleCloseModal}>
                                        <i className="fa fa-times"></i> Cancel
                                    </button>
                                    <button type="submit" className="nu-btn nu-btn-primary">
                                        <i className="fa fa-save"></i> Update User
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </Layout>
        </>
    )
}
